import { render, staticRenderFns } from "./SpecificVpt.vue?vue&type=template&id=2b74eae2&"
import script from "./SpecificVpt.vue?vue&type=script&lang=js&"
export * from "./SpecificVpt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports